import React from 'react';
// import AboutUsFormSection from '../components/aboutus-form-section';
// import LoanStepsSection from '../components/loan-steps-section';
// import WhyChooseUs from '../components/whychoose-us';
import AboutMain from '../components/about-main';
import MissionVision from '../components/mission-vision';
import WhyTrustUs from '../components/why-trust-us';
import HowItWorks from '../components/how-it-works';
// import Achievements from '../components/achievements';
import Review from '../components/review';
import KeyFeatures from "../components/KeyFeatures";
// import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-us-page">
      {/* Form Section */}
      {/* <AboutUsFormSection /> */}
       {/* <LoanStepsSection /> */}
       {/* <WhyChooseUs /> */}
       <AboutMain />
       <MissionVision />
       <WhyTrustUs />
       <HowItWorks />
       {/* <Achievements /> */}
       <KeyFeatures/>
       <Review />
    </div>
  );
};

export default AboutUs;
